import React from "react";
import webui, { BaseComponent } from "@tinqin/tinqin-web-ui";
import EntityBuilder from "@tinqin/tinqin-web-ui/src/utils/EntityBuilder";
import { xssFilter } from "../../common/utils/xssFilter";

class ArticleMutualAidBoxMini extends BaseComponent {
    onClick = () => {
        this.dispatchSirenActions(["default", "click"]);
    };

    render() {
        const data = this.props.data ? this.props.data.properties || {} : null;

        if (!data) {
            return "";
        }

        const dataEntity = EntityBuilder.of(this.props.data, { inplace: true });
        const title = dataEntity.getChild("title").getValue();
        const selected = dataEntity.getProperty("selected");
        const selectedClass = selected ? "un-theme-box-current" : "";

        return (
            <div
                className={`tq-banner un-lower-card un-lower-card-theme ${selectedClass}`}
                onClick={this.onClick.bind(this)}
            >
                <h2 className="tq-panel-title">
                    <span
                        className="tq-text-node"
                        dangerouslySetInnerHTML={{
                            __html: xssFilter.process(title)
                        }}
                    />
                </h2>
            </div>
        );
    }
}

export default webui.connectComponent({
    actions: {
        dispatchSirenActions: "siren.dispatchSirenActions"
    }
})(ArticleMutualAidBoxMini);
